import {gql} from '@apollo/client';

export const QUERY_SHOWCASE = gql`
    query getMoneyWwOffers ($token: String!, $locale: I18NLocaleCode, $geo: ENUM_GETMONEYWWSHOWCASE_GEO!) {
        getMoneyWwOffers(token: $token, locale: $locale, geo: $geo) {
            id
            attributes {
                info
                geo
                logo {
                    data {
                        id
                        attributes {
                            url
                        }
                    }
                }
                URL
            }
        }
    }
`